import { useQuery } from '@tanstack/react-query';
import { getOfferings } from '../../../services';
import { IBookingEvent } from '../../../types';

const useGetOfferings = () => {
  const offerings = useQuery<IBookingEvent[]>(['offerings'], getOfferings);

  return offerings;
};

export default useGetOfferings;
